import type { LibraryCollectionItem } from '@digital-twins/shared-types'
import httpClient from './http-client'

export interface AudienceLibraryState {
  inLibrary: boolean
  sourceDocument: { token: string; name: string } | null
}

export const libraryAudiencesApi = {
  createImportFromDocument: async (documentToken: string, language: string): Promise<{ sessionId: string }> => {
    const response = await httpClient.post(`/populations/import-sessions/from-document/${encodeURIComponent(documentToken)}`, { language })
    return response.data
  },
  list: async (): Promise<Array<LibraryCollectionItem>> => {
    const response = await httpClient.get('/knowledge/audiences')
    return response.data
  },
  getState: async (audienceToken: string): Promise<AudienceLibraryState> => {
    const response = await httpClient.get(`/knowledge/audiences/${encodeURIComponent(audienceToken)}`)
    return response.data
  },
}
